import _ from 'lodash'
import { GetterTree } from 'vuex'
import JobState, { IJobType } from './states'
import { State } from '@/store/store'

const getters: GetterTree<JobState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  jobById: (state) => {
    return state.byId
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  userById: (state) => {
    return state.list.user
  },
  patientById: (state) => {
    return state.list.patient
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
  jobType: (state) => (patientTypeId: string) => {
    const found = _.filter(state.jobType.data, (jobType) => jobType.patientTypes.includes(patientTypeId))
    return found
      ? _.map(found, (item) => {
          return { jobTypeId: item._id, text: item.name, period: item.period }
        })
      : ''
  },
  jobTypeName: (state) => (id: string) => {
    const found = _.find(state.jobType.data, (jobType) => jobType._id === id)
    return found ? found.name : ''
  },
  periodLists: (state) => (jobType: IJobType): Array<{
    text?: string,
    value?: string,
  }> => {
    // const data = _.find(state.jobType.data, (item) => item._id === jobType)
    return jobType && jobType.period && jobType.period.map((each) => {
      return {
        text: each,
        value: each,
      }
    })
  },
}

export default getters
